/* Experiencia "enciéndelo" (iluminación): interruptor que prende y apaga la foto REAL del producto y cambia de modo.
   Datos: { "tipo": "enciendelo", "foto_apagado": 2, "foto_encendido": 1,
            "modos": [ { "nombre": "Cálida", "foto": 1 }, { "nombre": "Blanca", "foto": 3 }, { "nombre": "Neutra", "color": "#FFE7C2" } ],
            "luz": [50, 30] (dónde está el bombillo, % de la foto; opcional), "regulable": true, "etiqueta": "Enciéndela" }
   Sin foto apagada: la foto encendida se oscurece y se marca "Apagada: ilustración". Un modo sin foto tiñe la foto y se
   marca "Tono de referencia". */
(function () {
  const TONOS = { calida: '#FFB868', 'luz calida': '#FFB868', amarilla: '#FFC46B', neutra: '#FFE6C4', natural: '#FFE6C4', blanca: '#E4EEFF', fria: '#D6E6FF',
    'luz blanca': '#E4EEFF', 'luz fria': '#D6E6FF', multicolor: 'conic-gradient(from 0deg,#ff6b6b,#ffd36b,#6bff9e,#6bc8ff,#b06bff,#ff6b6b)', rgb: 'conic-gradient(from 0deg,#ff6b6b,#ffd36b,#6bff9e,#6bc8ff,#b06bff,#ff6b6b)' };
  const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  NHX.registrar('enciendelo', function (root, d, x) {
    const modos = (Array.isArray(d.modos) ? d.modos : []).filter(m => m && m.nombre).map(m => ({ n: m.nombre, f: x.foto(m.foto), c: m.color || TONOS[norm(m.nombre)] || null }));
    const on = x.foto(d.foto_encendido) || (modos.find(m => m.f) || {}).f;
    if (!on) return false;
    const off = x.foto(d.foto_apagado);
    const luz = Array.isArray(d.luz) ? d.luz : null;
    x.oscuro(true);
    root.innerHTML =
      '<div class="xen">' +
        '<div class="xen__stage nhx-stage" style="aspect-ratio:' + (on.ar || 1) + '">' +
          (off ? x.imgTag(off, 'xen__img xen__off', { alt: 'Apagado' }) : x.imgTag(on, 'xen__img xen__off is-sim', { alt: 'Apagado (ilustración)' })) +
          '<div class="xen__on">' + x.imgTag(on, 'xen__img xen__onimg', { alt: 'Encendido' }) + '<div class="xen__tinte"></div></div>' +
          (luz ? '<span class="xen__halo" style="left:' + luz[0] + '%;top:' + luz[1] + '%"></span>' : '') +
          '<span class="xen__tag" data-tag hidden></span>' +
          x.pista('Toca el interruptor', 'toca') +
        '</div>' +
        '<div class="xen__panel">' +
          '<button type="button" class="xen__sw" role="switch" aria-checked="false" aria-label="Encender"><span class="xen__sw-k"></span><span class="xen__sw-t" data-swt>Apagado</span></button>' +
          (modos.length > 1 ? '<div class="nhx-seg xen__modos" role="group" aria-label="Modo de luz">' + modos.map((m, i) => '<button type="button" aria-pressed="' + (i === 0) + '" data-m="' + i + '"><i style="background:' + (m.c || '#FFD9A0') + '"></i>' + x.esc(m.n) + '</button>').join('') + '</div>' : '') +
          (d.velocidades ? '<span class="xen__vel">' + x.esc(d.velocidades) + ' velocidades</span>' : '') +
          (d.regulable ? '<label class="xen__dim"><span>Intensidad</span><input type="range" class="nhx-range" min="25" max="100" value="100" aria-label="Intensidad de la luz"></label>' : '') +
        '</div>' +
        (d.nota ? '<p class="nhx-note">' + x.esc(d.nota) + '</p>' : '') +
      '</div>';
    const st = root.querySelector('.xen__stage'), sw = root.querySelector('.xen__sw'), onWrap = st.querySelector('.xen__on'), onImg = st.querySelector('.xen__onimg');
    const tinte = st.querySelector('.xen__tinte'), tag = st.querySelector('[data-tag]'), swt = root.querySelector('[data-swt]');
    let prendido = false, modo = 0, brillo = 1;
    function etiqueta() {
      const t = [];
      if (!prendido && !off) t.push('Apagado: ilustración');
      if (prendido && modos[modo] && !modos[modo].f && modos[modo].c) t.push('Tono de referencia');
      if (prendido && d.regulable && brillo < 0.99) t.push('Intensidad: ilustración');
      tag.hidden = !t.length; tag.textContent = t.join(' · ');
    }
    function pintar() {
      st.classList.toggle('is-on', prendido);
      root.closest('.nhx').classList.toggle('xen-on', prendido);
      sw.setAttribute('aria-checked', prendido); sw.setAttribute('aria-label', prendido ? 'Apagar' : 'Encender');
      swt.textContent = prendido ? 'Encendido' : 'Apagado';
      onWrap.style.opacity = prendido ? (0.35 + 0.65 * brillo) : 0;
      const m = modos[modo];
      const color = (m && m.c) || '#FFC982';
      root.closest('.nhx').style.setProperty('--xen-glow', color.indexOf('gradient') >= 0 ? '#C9A2FF' : color);
      tinte.style.background = m && !m.f && m.c ? m.c : 'transparent';
      etiqueta();
    }
    function ponerModo(i) {
      modo = i;
      root.querySelectorAll('[data-m]').forEach(b => b.setAttribute('aria-pressed', +b.dataset.m === i));
      const m = modos[i];
      const nueva = (m && m.f) || on;
      if (onImg.getAttribute('src') !== nueva.src) {
        x.precargar(nueva.src).then(() => { onImg.classList.add('is-swap'); setTimeout(() => { onImg.src = nueva.src; onImg.classList.remove('is-swap'); }, 160); });
      }
      if (!prendido) prendido = true;
      pintar();
    }
    sw.addEventListener('click', () => { st.classList.add('is-tocado'); prendido = !prendido; if (navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} } pintar(); });
    root.querySelectorAll('[data-m]').forEach(b => b.addEventListener('click', () => { st.classList.add('is-tocado'); ponerModo(+b.dataset.m); }));
    const dim = root.querySelector('.xen__dim input');
    if (dim) dim.addEventListener('input', () => { brillo = dim.value / 100; dim.style.setProperty('--k', ((dim.value - 25) / 75 * 100) + '%'); if (!prendido) prendido = true; pintar(); });
    if (dim) dim.style.setProperty('--k', '100%');
    // tocar la foto también prende/apaga
    st.addEventListener('click', e => { if (e.target.closest('button')) return; sw.click(); });
    if (modos.length && modos[0].f) onImg.src = modos[0].f.src;
    pintar();
    x.alVer(st, () => setTimeout(() => { if (!st.classList.contains('is-tocado')) { prendido = true; pintar(); } }, 700), 0.55);
  });
})();
